import { render, staticRenderFns } from "./ListTabelasPrecoSelect.vue?vue&type=template&id=68a9ebc8&"
import script from "./ListTabelasPrecoSelect.vue?vue&type=script&lang=js&"
export * from "./ListTabelasPrecoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCol,VPagination})
